import { ViewType } from "@/lib/types";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { ChevronDown } from "lucide-react";

interface ViewSelectorProps {
  activeView: ViewType;
  onChange: (view: ViewType) => void;
}

export default function ViewSelector({ activeView, onChange }: ViewSelectorProps) {
  const views: { id: ViewType; label: string }[] = [
    { id: "timeline", label: "Timeline" },
    { id: "daily", label: "Daily View" },
    { id: "list", label: "List View" },
    { id: "map", label: "Map" },
    { id: "proposals", label: "Proposals" }
  ];

  // Find the active view label
  const activeViewLabel = views.find(view => view.id === activeView)?.label || "Timeline";

  return (
    <Select
      value={activeView}
      onValueChange={(value) => onChange(value as ViewType)}
    >
      <SelectTrigger 
        className="w-[180px] bg-gray-200 border-gray-300"
      >
        <SelectValue placeholder={activeViewLabel} />
      </SelectTrigger>
      <SelectContent>
        {views.map((view) => (
          <SelectItem key={view.id} value={view.id}>
            {view.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
